import { render, staticRenderFns } from "./PayMethods.vue?vue&type=template&id=f1791fc8&scoped=true&"
import script from "./PayMethods.vue?vue&type=script&lang=js&"
export * from "./PayMethods.vue?vue&type=script&lang=js&"
import style0 from "./PayMethods.vue?vue&type=style&index=0&id=f1791fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1791fc8",
  null
  
)

export default component.exports